export enum roles {
  'admin' = 'admin', // Администратор
  'editor' = 'editor', // Редактор
  'author' = 'author', // Автор
  'student' = 'student', // Студент
  'cttMC' = 'cttMC', // ЛК Сотрудника ЦМ
  'cttIPC' = 'cttIPC' // ЛК Сотрудника ЦИС
}

export const rolesTranslation: { [k: string]: string } = {
  [roles.admin]: 'Администратор',
  [roles.editor]: 'Редактор',
  [roles.author]: 'Автор',
  [roles.student]: 'Студент',
  [roles.cttMC]: 'Сотрудник ЦМ',
  [roles.cttIPC]: 'Сотрудник ЦИС'
}

export const rolesBadges: { [k: string]: string } = {
  [roles.admin]: 'Адм',
  [roles.editor]: 'Р',
  [roles.author]: 'Ав',
  [roles.student]: 'Ст',
  [roles.cttMC]: 'ЦМ',
  [roles.cttIPC]: 'ЦИС'
}
